"use client";
import { useState, useEffect } from "react";
import type { mousePositionType } from "../types";

export function useMousePosition() {
  const [mousePosition, setMousePosition] = useState<mousePositionType>({
    x: null,
    y: null,
  });

  useEffect(() => {
    const updateMousePosition = (event: MouseEvent | any) => {
      setMousePosition({ x: event.clientX, y: event.clientY });
    };

    window.addEventListener("mousemove", updateMousePosition);

    return () => {
      window.removeEventListener("mousemove", updateMousePosition);
    };
  }, []);

  return mousePosition;
}
